import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  radioList: (props) => ({
    display: 'flex',
    flexDirection: props.orientation === 'vertical' ? 'column' : 'row',
  }),
});

export default useStyle;
